import React, {useRef, useState, useEffect} from 'react';
import styles from './BackgroundMusic.module.scss'
import {buttonClick} from "utils/Helpers";
import SoundOff from "components/icons/soundOff/SoundOff";
import SoundOn from "components/icons/soundOn/SoundOn";
import {useSelector} from "react-redux";

const BackgroundMusic = (props) => {

    const accessible = useSelector(state => state.accessible);
    const panelData = useSelector(state => state.panelData);
    const [muted, setMuted] = useState(true);
    const bgMusic = useRef();
    const wasPlaying = useRef(false)

    function getSoundClass(){

        let dark = panelData.stackOrder.cache === 'active' || panelData.stackOrder.martellus === 'active' ? styles.dark : ''
        return `${styles.sound} ${dark}`
    }

    function toggleBackgroundMusic(override){
        let active = !override || !muted;
        setMuted(active);
        if(active){
            bgMusic.current.pause();
            wasPlaying.current = false;
        } else {
            bgMusic.current.volume = 0.1;
            bgMusic.current.play();
            wasPlaying.current = true;
        }

    }

    useEffect(()=>{

        if(!bgMusic.current.paused && accessible.videoActive){
            bgMusic.current.pause();
        }

        if(!accessible.videoActive && wasPlaying.current){
            bgMusic.current.volume = 0.1;
            bgMusic.current.play();
        }
    }, [accessible.videoActive])

    return (
        <div aria-hidden={props.hide} tabIndex={accessible.siteEntered && !accessible.modalOpen  ? 0 : null}
             role={'button'} aria-label={'Sound Toggle'}
             onKeyDown={buttonClick}  onClick={toggleBackgroundMusic}
             className={getSoundClass()}>
            <span>{muted ? <SoundOff/> : <SoundOn/>}</span>
            <audio ref={bgMusic} controls={false} loop>
                <source src="https://msobd-storage.azureedge.net/videos/background.mp3" type="audio/mpeg"/>
            </audio>
        </div>
    )
};

export default BackgroundMusic
